import Template00 from "./Template-00"
import Template01 from "./Template-01"

export default {
    Template00,
    Template01,
}
